import getBanksFromAggregatorData from './getBanksFromAggregatorData'

const getBanksCode = immAggregatorData => {
    const bankList = getBanksFromAggregatorData(immAggregatorData)
    const hasAggregatedBanks = bankList.length > 0;

    return hasAggregatedBanks ? bankList.map(bank => bank.code) : null
}

export default getBanksCode